import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@narvar/nth-button';
import PickupDate from './PickupDate';
import s from './Instruction.module.css';
import { timeWindowFormatter } from '../../lib/dates';

const mapStateToProps = ({
  page: { countryCode } = {},
  language,
  retailerSettings: { branding: { brand_call_to_action: brandCTAColor } = {} } = {},
}) => ({
  language,
  brandCTAColor,
  countryCode,
});

const Instruction = ({ language, number, button, onClick, date, pickupTime, countryCode }) => {
  const {
    [`returns.pickups_page.instructions[${number}].header`]: header,
    [`returns.pickups_page.instructions[${number}].description`]: description,
    [`returns.pickups_page.instructions[${number}].time_window`]: descriptionTimeWindow,
    [`returns.pickups_page.instructions[${number}].button`]: buttonText,
  } = language;

  const parsePickupTimeString = (time) => {
    const [from, to] = timeWindowFormatter(time, countryCode).split('-');
    return descriptionTimeWindow.replace('{from}', from).replace('{to}', to);
  };

  return (
    <li>
      <div className={s.list_number}>{number}</div>
      <div className={s.instruction_content}>
        <div className={s.instruction} dangerouslySetInnerHTML={{ __html: header }} />
        {date && <PickupDate date={date} />}
        {pickupTime && descriptionTimeWindow ? (
          parsePickupTimeString(pickupTime)
        ) : (
          <div style={{ marginTop: '5px' }} dangerouslySetInnerHTML={{ __html: description }} />
        )}
        {button && (
          <div className={s.print_button_container}>
            <div className={s.print_button}>
              <Button
                className="narvar-btn-primary reprint-btn"
                s={{ fontSize: '14px', fontFamily: 'inherit' }}
                onClick={onClick}
              >
                {buttonText}
              </Button>
            </div>
          </div>
        )}
      </div>
      <div className="clearfix" />
    </li>
  );
};

const InstructionList = ({ children }) => (
  <div className={s.container}>
    <div>
      <ol className={s.list}>{children}</ol>
    </div>
  </div>
);

Instruction.propTypes = {
  language: PropTypes.object.isRequired,
  number: PropTypes.number,
  button: PropTypes.bool,
  onClick: PropTypes.func,
  brandCTAColor: PropTypes.string,
  date: PropTypes.string,
  pickupTime: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
};
Instruction.defaultProps = {
  number: null,
  button: false,
  onClick: null,
  brandCTAColor: '#000000',
  date: null,
  pickupTime: null,
};

InstructionList.propTypes = { children: PropTypes.node };

InstructionList.defaultProps = { children: null };

export default connect(mapStateToProps)(Instruction);
export { InstructionList, Instruction };
